module.exports = __webpack_public_path__ + "static/media/UX.0f9e1950.png";